import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
	loadProjectListFilters: () => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'new-project-wizard/details-filters',
				method: 'GET',
				types: [
					types.NEW_PROJECT_WIZARD_DETAILS_FILTERS_REQUEST,
					types.NEW_PROJECT_WIZARD_DETAILS_FILTERS_SUCCESS,
					types.NEW_PROJECT_WIZARD_DETAILS_FILTERS_FAILURE,
				],
			},
		});
	},

	searchLocations: (request) => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'new-project-wizard/location-search',
				method: 'POST',
				body: request,
				types: [
					types.NEW_PROJECT_WIZARD_LOCATION_SEARCH_REQUEST,
					types.NEW_PROJECT_WIZARD_LOCATION_SEARCH_SUCCESS,
					types.NEW_PROJECT_WIZARD_LOCATION_SEARCH_FAILURE,
				],
			},
		});
	},

	listLinkBaselines: (request) => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'new-project-wizard/list-link-baselines',
				method: 'GET',
				body: request,
				types: [
					types.NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_REQUEST,
					types.NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_SUCCESS,
					types.NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_FAILURE,
				],
			},
		});
	},

	listCopyBaselines: (request) => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'new-project-wizard/list-copy-baselines',
				method: 'GET',
				body: request,
				types: [
					types.NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_REQUEST,
					types.NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_SUCCESS,
					types.NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_FAILURE,
				],
			},
		});
	},

	copyProjectBaselines: (request) => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'new-project-wizard/copy-project-baselines',
				method: 'POST',
				body: request,
				types: [
					types.NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_REQUEST,
					types.NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_SUCCESS,
					types.NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_FAILURE,
				],
			},
		});
	},

	import: (projectKey, file, baselineId) => (dispatch) => {
		let body = new FormData();
		body.append('file', file);
		body.append('projectkey', projectKey);

		if (baselineId !== undefined)
			body.append('baselineId', baselineId);

		return dispatch({
			[CALL_API]: {
				endpoint: 'new-project-wizard/import',
				method: 'POST',
				body: body,
				types: [
					types.NEW_PROJECT_WIZARD_IMPORT_BASELINE_REQUEST,
					types.NEW_PROJECT_WIZARD_IMPORT_BASELINE_SUCCESS,
					types.NEW_PROJECT_WIZARD_IMPORT_BASELINE_FAILURE,
				],
			},
		});
	},

	saveBaselineTask: (baselineTask) => (dispatch) => {
		if (baselineTask.id === 0 || baselineTask.id === undefined) {
			return dispatch({
				[CALL_API]: {
					endpoint: 'new-project-wizard/create-baseline-task',
					method: 'POST',
					body: baselineTask,
					types: [
						types.NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_REQUEST,
						types.NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_SUCCESS,
						types.NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_FAILURE,
					],
				},
			});
		} else {
			return dispatch({
				[CALL_API]: {
					endpoint: 'new-project-wizard/update-baseline-task',
					method: 'PUT',
					body: baselineTask,
					types: [types.UPDATE_BASELINE_TASK_REQUEST, types.UPDATE_BASELINE_TASK_SUCCESS, types.UPDATE_BASELINE_TASK_FAILURE],
				},
			});
		}
	},

	loadFormFilters: (subscriptionId, baselineId) => {
		return (dispatch) => {
			const body = {
				subscriptionId: subscriptionId,
				baselineId: baselineId,
			};
			return dispatch({
				[CALL_API]: {
					endpoint: 'new-project-wizard/form-filters',
					method: 'POST',
					body: body,
					types: [
						types.LOAD_NEW_PROJECT_FORM_FILTERS_REQUEST,
						types.LOAD_NEW_PROJECT_FORM_FILTERS_SUCCESS,
						types.LOAD_NEW_PROJECT_FORM_FILTERS_FAILURE,
					],
				},
			});
		};
	},
};
